import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustFeatures = [
    {
      icon: 'Shield',
      title: 'Secure & Encrypted',
      description: 'Your data is protected with bank-level security'
    },
    {
      icon: 'Users',
      title: '2M+ Happy Travelers',
      description: 'Join millions who trust TourEase for their adventures'
    },
    {
      icon: 'Award',
      title: 'Award Winning',
      description: 'Recognized as Best Travel Platform 2024'
    },
    {
      icon: 'Clock',
      title: '24/7 Support',
      description: 'Round-the-clock assistance for your peace of mind'
    }
  ];

  const securityBadges = [
    {
      name: 'SSL Secured',
      icon: 'Lock',
      color: 'text-success'
    },
    {
      name: 'GDPR Compliant',
      icon: 'Shield',
      color: 'text-primary'
    },
    {
      name: 'PCI DSS',
      icon: 'CreditCard',
      color: 'text-accent'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Trust Features */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {trustFeatures?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name={feature?.icon} size={20} className="text-primary" />
            </div>
            <div>
              <h3 className="font-medium text-foreground text-sm">{feature?.title}</h3>
              <p className="text-xs text-muted-foreground mt-1">{feature?.description}</p>
            </div>
          </div>
        ))}
      </div>
      {/* Security Badges */}
      <div className="pt-6 border-t border-border">
        <p className="text-xs text-muted-foreground text-center mb-4">
          Protected by industry-leading security standards
        </p>
        <div className="flex items-center justify-center space-x-6">
          {securityBadges?.map((badge, index) => (
            <div key={index} className="flex items-center space-x-1">
              <Icon name={badge?.icon} size={14} className={badge?.color} />
              <span className="text-xs font-medium text-muted-foreground">
                {badge?.name}
              </span>
            </div>
          ))}
        </div>
      </div>
      {/* Member Benefits */}
      <div className="bg-gradient-to-r from-primary/5 to-accent/5 rounded-lg p-4">
        <div className="text-center">
          <Icon name="Star" size={20} className="text-accent mx-auto mb-2" />
          <h3 className="font-medium text-foreground text-sm mb-1">
            Exclusive Member Benefits
          </h3>
          <p className="text-xs text-muted-foreground">
            Early access to deals • Priority support • Loyalty rewards
          </p>
        </div>
      </div>
      {/* Privacy Policy Link */}
      <div className="text-center">
        <p className="text-xs text-muted-foreground">
          By continuing, you agree to our{' '}
          <a href="#" className="text-primary hover:text-primary/80 underline">
            Terms of Service
          </a>{' '}
          and{' '}
          <a href="#" className="text-primary hover:text-primary/80 underline">
            Privacy Policy
          </a>
        </p>
      </div>
    </div>
  );
};

export default TrustSignals;